import type { H3Error } from 'h3'
import { requestOrThrow } from '../api-client'
import type {
  Group,
  GroupMember,
  CreateGroupRequest,
  UpdateGroupRequest,
  CreateMemberRequest,
  UpdateMemberRequest,
} from '../group'

// SubProfile(代理グループ/サブメンバー)の API 境界(stateless)。グループは単数リソース
// (メイン1つにつき1つ)。認証付与と camelCase⇔snake_case 変換は custom-fetch が担当。
// エンドポイントは生成 OAS の /me/proxy_group・/me/proxy_group/sub_members(/{id})。
const GROUP_PATH = 'me/proxy_group'
const SUB_MEMBERS_PATH = 'me/proxy_group/sub_members'

export function getGroup() {
  // 未作成時は 404。「グループ未作成」= null に正規化し、利用側の空状態分岐を API 表現に依存させない。
  return requestOrThrow<Group | null>(GROUP_PATH).catch((error: unknown) => {
    if ((error as H3Error).statusCode === 404) return null
    throw error
  })
}

export function createGroup(body: CreateGroupRequest) {
  return requestOrThrow<Group>(GROUP_PATH, { method: 'POST', body })
}

export function updateGroup(body: UpdateGroupRequest) {
  return requestOrThrow<Group>(GROUP_PATH, { method: 'PATCH', body })
}

export function deleteGroup() {
  return requestOrThrow<unknown>(GROUP_PATH, { method: 'DELETE' })
}

export function addGroupMember(body: CreateMemberRequest) {
  return requestOrThrow<GroupMember>(SUB_MEMBERS_PATH, { method: 'POST', body })
}

export function updateGroupMember(memberId: number, body: UpdateMemberRequest) {
  return requestOrThrow<GroupMember>(`${SUB_MEMBERS_PATH}/${memberId}`, {
    method: 'PATCH',
    body,
  })
}

export function deleteGroupMember(memberId: number) {
  return requestOrThrow<unknown>(`${SUB_MEMBERS_PATH}/${memberId}`, { method: 'DELETE' })
}
